import { schema } from "normalizr";
import { gameEntity } from "./game";

export const superlativeEntity = new schema.Entity("superlatives", {
  gameId: gameEntity,
});
